var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from 'react';
import { isOptionGroup } from './utils';
import { SelectBase } from './SelectBase';
var Select = function (_a) {
    var _b = _a.closeMenuOnSelect, closeMenuOnSelect = _b === void 0 ? true : _b, onChange = _a.onChange, _c = _a.options, options = _c === void 0 ? [] : _c, value = _a.value, rest = __rest(_a, ["closeMenuOnSelect", "onChange", "options", "value"]);
    var handleChange = useCallback(function (option) {
        if (onChange) {
            onChange(option ? option.value : null);
        }
    }, [onChange]);
    var flatOptions = useMemo(function () { return options.flatMap(function (opt) { return (isOptionGroup(opt) ? opt.options : opt); }); }, [options]);
    var selectedOption = useMemo(function () { return flatOptions.find(function (opt) { return opt.value === value; }) || null; }, [flatOptions, value]);
    return (React.createElement(SelectBase, __assign({}, rest, { closeMenuOnSelect: closeMenuOnSelect, multiselect: false, onChange: handleChange, options: options, value: selectedOption })));
};
export default Select;
//# sourceMappingURL=Select.js.map